import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getBuyerPhoneNumber = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IWantedPhoneNumber} = await request.get(
    `/api/v2/market/post-phone-number?post_type=wanted&guid=${ctx.queryKey[2]}`,
  );
  return data;
};
